'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
var MaterialDrop = require('../../01.atoms/MaterialDrop/MaterialDrop.js');
var ReactDOM = _interopDefault(require('react-dom'));
var reactRouter = require('react-router');
require('./_index.scss.js');

var CLASSNAME = 'varta-modal',
    cnOpen = "".concat(CLASSNAME, "--open"),
    cnFullscreen = "".concat(CLASSNAME, "--fullscreen"),
    cnFixed = "".concat(CLASSNAME, "--fixed"),
    cnWrapper = "".concat(CLASSNAME, "__wrapper"),
    cnInnerWrapper = "".concat(CLASSNAME, "__inner-wrapper"),
    cnInnerWrapperSmall = "".concat(cnInnerWrapper, "--small"),
    cnContent = "".concat(CLASSNAME, "__content"),
    cnContentPadding = "".concat(cnContent, "--padding"),
    cnClose = "".concat(CLASSNAME, "__close"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnImage = "".concat(CLASSNAME, "__image");
/**
 * 
 */

var Modal = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Modal, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Modal);

  function Modal() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {});

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "overlay", /*#__PURE__*/React__default.createRef());

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "wrapper", /*#__PURE__*/React__default.createRef());

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onRouteChangeStart", function () {
      var open = _this.props.open;

      if (open) {
        _this.onClose();
      }
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onOverlayClick", function (e) {
      var closeOnClickOutside = _this.props.closeOnClickOutside;

      if (closeOnClickOutside && (e.target === _this.overlay.current || e.target === _this.wrapper.current)) {
        _this.onClose(e);
      }

      e.stopPropagation();
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onClose", function (e) {
      if (e) {
        e.stopPropagation();
      }

      var onClose = _this.props.onClose;
      onClose();

      _this.setState({
        top: undefined
      });
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.unlisten = reactRouter.browserHistory === null || reactRouter.browserHistory === void 0 ? void 0 : reactRouter.browserHistory.listen(function (location) {
        _this2.onRouteChangeStart.bind(_this2);
      }); // Router?.events.on('routeChangeStart', this.onRouteChangeStart)
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      this.unlisten = reactRouter.browserHistory === null || reactRouter.browserHistory === void 0 ? void 0 : reactRouter.browserHistory.listen(function (location) {
        _this3.onRouteChangeStart.bind(_this3);
      }); // Router?.events.off('routeChangeStart', this.onRouteChangeStart)

      document.body.classList.remove(cnOpen);
      document.body.classList.remove(cnFullscreen);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this4 = this;

      var _this$props = this.props,
          open = _this$props.open,
          fullscreen = _this$props.fullscreen,
          fixed = _this$props.fixed,
          fn = open ? 'add' : 'remove';

      if (prevProps.open === open && prevProps.fullscreen === fullscreen) {
        return;
      }

      if (typeof document === 'undefined') {
        return;
      }

      if (open && !this.scrollY) {
        // store scorllposition before hiding content
        this.scrollY = window.scrollY || window.pageYOffset;
      }

      document.body.classList[fn](cnOpen);

      if (fixed) {
        document.body.classList[fn](cnFixed);
      }

      if (fullscreen) {
        document.body.classList[fn](cnFullscreen);

        if (open) {
          // scroll modal content into view
          window.scrollTo(0, 0);
        }
      } else {
        document.body.classList.remove(cnFullscreen);
      }

      if (fullscreen && !open && typeof this.scrollY === 'number') {
        // reset scroll position after closing modal
        window.requestAnimationFrame(function () {
          window.scrollTo(0, _this4.scrollY);
          _this4.scrollY = undefined;
        }, 32);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          open = _this$props2.open,
          children = _this$props2.children,
          title = _this$props2.title,
          showCloseButton = _this$props2.showCloseButton,
          className = _this$props2.className,
          classNameContent = _this$props2.classNameContent,
          fullscreen = _this$props2.fullscreen,
          fixed = _this$props2.fixed,
          small = _this$props2.small,
          noPadding = _this$props2.noPadding,
          zIndex = _this$props2.zIndex,
          image = _this$props2.image;
      var top = this.state.top;

      if (!open || typeof document === 'undefined') {
        return null;
      }

      return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React__default.createElement("div", {
        className: classNames(CLASSNAME, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnFullscreen, fullscreen), _rollupPluginBabelHelpers.defineProperty(_classNames, cnFixed, fixed), _classNames)),
        onClick: this.onOverlayClick,
        ref: this.overlay,
        style: {
          zIndex: zIndex
        }
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapper,
        style: {
          top: top
        },
        ref: this.wrapper
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames(cnInnerWrapper, className, _rollupPluginBabelHelpers.defineProperty({}, cnInnerWrapperSmall, small))
      }, showCloseButton && /*#__PURE__*/React__default.createElement("button", {
        onClick: this.onClose,
        className: cnClose
      }, /*#__PURE__*/React__default.createElement(Icon, {
        id: "times",
        size: "sm"
      }), /*#__PURE__*/React__default.createElement(MaterialDrop, null)), image && /*#__PURE__*/React__default.createElement("img", {
        className: cnImage,
        src: image
      }), title && /*#__PURE__*/React__default.createElement("h3", {
        className: cnTitle
      }, title), /*#__PURE__*/React__default.createElement("div", {
        className: classNames(cnContent, classNameContent, _rollupPluginBabelHelpers.defineProperty({}, cnContentPadding, !noPadding))
      }, children)))), document.querySelector('#stageFullscreen'));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (!props.fixed && props.open && typeof state.top === 'undefined') {
        return {
          top: window.scrollY || window.pageYOffset
        };
      }

      return null;
    }
  }]);

  return Modal;
}(React__default.Component);
Modal.propTypes = {
  /** Child nodes */
  children: PropTypes.node,

  /** Additional class name for modal content */
  classNameContent: PropTypes.string,

  /** Additional class name */
  className: PropTypes.string,

  /** If true modal can be closed by clicking outside */
  closeOnClickOutside: PropTypes.bool,

  /** True if modal should be fixed */
  fixed: PropTypes.bool,

  /** True for fullscreen display */
  fullscreen: PropTypes.bool,

  /** Path to image that  */
  image: PropTypes.string,

  /** True for no padding styling */
  noPadding: PropTypes.bool,

  /** Callback function on close */
  onClose: PropTypes.func,

  /** If true Modal is displayed */
  open: PropTypes.bool,

  /** True displays x in top right corner */
  showCloseButton: PropTypes.bool,

  /** True for smaller styling */
  small: PropTypes.bool,

  /** Heading */
  title: PropTypes.string,

  /** CSS z-index value */
  zIndex: PropTypes.number
};
Modal.defaultProps = {
  onClose: function onClose() {
    return void 0;
  },
  closeOnClickOutside: true,
  fixed: true,
  small: true
};

module.exports = Modal;
